import { render } from "./InsightsWatchlistView.vue?vue&type=template&id=c9b61514&ts=true"
import script from "./InsightsWatchlistView.vue?vue&type=script&lang=ts"
export * from "./InsightsWatchlistView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__